<template>
  <div class="navigation" :class="{ disabled: disabled }">
    <div class="inner-navigation" @click.capture="preventRoutingIfDisabled">
      <router-link :to="{ name: 'vacancy-preferences-settings' }" active-class="active">
        <span>{{ $tr('vacancy.preferences.title') }}</span>
      </router-link>

      <router-link
        :to="videointerviewRoute"
        active-class="active"
        :class="{ navigation__item_active: isModuleEnabled('video_interview') }"
      >
        <span>{{ $tr('vacancy.videoInterview.title') }}</span>
      </router-link>

      <router-link :to="{ name: 'vacancy-preferences-competencies' }" active-class="active">
        <span>{{ $tr('common.navigation.competencies') }}</span>
      </router-link>

      <router-link :to="{ name: 'vacancy-tests' }" active-class="active">
        <span>{{ $tr('vacancy.test.title') }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';

export default {
  name: 'ProcessVacanciesNavigation',

  directives: {
    onClickaway
  },

  props: {
    model: Object,
    disabled: Boolean
  },

  data() {
    return {
      preferencesDropdownOpened: false,
      preferencesDropdownId: null
    };
  },

  computed: {
    searchbotRoute() {
      return {
        name: 'vacancy-search-bot',
        params: {
          id: this.model.id || '0'
        }
      };
    },

    landingRoute() {
      return {
        name: 'vacancy-landing',
        params: {
          id: this.model.id || '0'
        }
      };
    },

    testRoute() {
      return {
        name: 'vacancy-test',
        params: {
          id: this.model.id || '0'
        }
      };
    },

    voicebotRoute() {
      return {
        name: 'vacancy-voice-bot',
        params: {
          id: this.model.id || '0'
        }
      };
    },

    videointerviewRoute() {
      return {
        name: 'vacancy_video',
        params: {
          id: this.model.id || '0'
        }
      };
    },

    preferencesRoute() {
      return {
        path: `/vacancies/${this.model.id || '0'}/preferences`
      };
    }
  },

  methods: {
    preventRoutingIfDisabled(event) {
      if (this.disabled) {
        event.preventDefault();
      }
    },

    isModuleEnabled(name) {
      return (
        !this.disabled &&
        this.model.modules &&
        this.model.modules.length !== 0 &&
        this.model.modules.find(module => module.name === name).is_active
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/components/vacancy/Navigation.scss';
</style>
